import { cn } from "../../../lib/utils"

/**
 * Enhanced Skeleton component with subtle shimmer effect
 * Creates a modern, elegant loading skeleton with smooth shimmer animation
 */
function Skeleton({ className, glow = true, ...props }) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-muted relative overflow-hidden",
        glow && "skeleton-glow",
        className
      )}
      {...props}
    >
      {/* Subtle shimmer overlay - modern loading indicator */}
      {glow && (
        <div 
          className="absolute inset-0 skeleton-shimmer"
          aria-hidden="true"
        />
      )}
    </div>
  )
}

export { Skeleton } 